import { MantineBreakpoint, MantineSize } from '@mantine/core';

// Breakpoint for determining when to show mobile vs desktop components
export const DESKTOP_BREAKPOINT_WIDE: MantineBreakpoint = 'lg';

export const DESKTOP_BREAKPOINT: MantineBreakpoint = 'sm';
export const DESKTOP_BREAKPOINT_NUMBER = 768;

export const TABLET_BREAKPOINT: MantineBreakpoint = 'xs';

// Table constants
export const TABLE_MIN_WIDTH = 800;
export const TABLE_MIN_WIDTH_SMALL = 300;

// Related to prescription approval
export enum ApprovalStep {
    INITIAL = 'INITIAL',
    OTHER_PENDING_PRESCRIPTIONS = 'OTHER_PENDING_PRESCRIPTIONS',
    SUBSTITUTION_RECOMMENDATION = 'SUBSTITUTION_RECOMMENDATION',
}
export const APPROVAL_SECTION_SPACING: MantineSize = 'lg';

// Keys to use when using the `useLocalStorage` hook
// Anyone can use these same keys to read from any component, without worrying about global state or context
export enum LOCAL_STORAGE_KEYS {
    ADMIN_PRACTICE_FILTER = 'admin-practice-filter',
    ADMIN_PHARMACY_PARTNER_FILTER = 'admin-pharmacy-partner-filter',
    ADMIN_TASK_TYPE_FILTER = 'admin-task-type-filter',
    ADMIN_WORKS_WITH_3P_PHARMACIES_FILTER = 'admin-works-with-3p-pharmacies-filter',

    // Most recently selected practice UUID, helpful for remembering the last practice the user was viewing
    LAST_SELECTED_PRACTICE_UUID = 'last-selected-practice-uuid',

    INBOX_SNAPSHOT = 'inbox-snapshot',

    // Prescriptions page status filters to apply across page transitions and refreshes
    PRESCRIPTIONS_DEBOUNCED_SEARCH = 'prescriptions-filter__debounced-search',
    PRESCRIPTIONS_STATUS_FILTER = 'prescriptions-filter__status',
    PRESCRIPTIONS_DATE_RANGE = 'prescriptions-filter__date-range',

    // Reports status filters
    REPORTS_DATE_RANGE = 'reports-filter__date-range',

    // Whether the sidenav should be open or closed
    SIDENAV_OPEN_STATE = 'sidenav-open-state',

    // Last dragged width of the dvmReach Inbox thread list (pixels)
    REACH_INBOX_LIST_WIDTH = 'reach-inbox-list-width',

    // Last dragged width of the dvmReach Inbox client details pane (pixels)
    REACH_INBOX_DETAILS_WIDTH = 'reach-inbox-details-width',

    // Whether each dvmReach Inbox side pane is collapsed
    REACH_INBOX_LIST_COLLAPSED = 'reach-inbox-list-collapsed',
    REACH_INBOX_DETAILS_COLLAPSED = 'reach-inbox-details-collapsed',

    // Prefix for the inbox Active CSR pick (appended with practice id and Auth0 user id)
    REACH_INBOX_ACTIVE_CSR_PREFIX = 'reach-inbox-active-csr',

    // Prefix for when this login last read each inbox thread (appended with practice id and Auth0
    // user id). Read state is client-side only - no endpoint carries it
    REACH_INBOX_READ_AT_PREFIX = 'reach-inbox-read-at',

    // Prefix for which inbox threads the prototype has already given a starting read mark. Mock
    // scaffolding, deleted with the fixtures - see `seedInboxReadState`
    REACH_INBOX_READ_SEEDED_PREFIX = 'reach-inbox-read-seeded',

    // Whether to autoplay AI-generated recordings after generation
    RECORDING_AUTOPLAY = 'recording-autoplay',

    // Playback speed for previewing AI-generated recordings
    RECORDING_PLAYBACK_SPEED = 'recording-playback-speed',

    // Prefix for per-entity SMS consent confirmation cache (appended with entity ID)
    SMS_CONSENT_CONFIRMED_PREFIX = 'sms-consent-confirmed',
}

export enum SESSION_STORAGE_KEYS {
    INBOX_EMPLOYEE_FILTER = 'inbox-employee-filter',

    // Frozen clock the inbox mock generators draw timestamps from. Prototype-only; deleted with
    // the fixtures. See `getInboxMockNow`
    REACH_INBOX_MOCK_NOW = 'reach-inbox-mock-now',
}

// Some sensible defaults
export const MAX_BUTTON_WIDTH = '240px';

// Debounce time for search inputs
export const DEBOUNCE_TIME_MS = 500;

// For pagination throughout the app
export const DEFAULT_PAGE_SIZE = 20;
